module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med tjenesteløfte_primærlogo_neg(hvit).7f018404.png";